import { render, staticRenderFns } from "./Clientspopup.vue?vue&type=template&id=ac9eaa28"
import script from "./Clientspopup.vue?vue&type=script&lang=js"
export * from "./Clientspopup.vue?vue&type=script&lang=js"
import style0 from "./Clientspopup.vue?vue&type=style&index=0&id=ac9eaa28&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports